
let metaTags = {
    "/": {
      title: "ASTRNT – Transforming Hiring and Admissions",
      description: "ASTRNT transforms hiring, admissions, and talent management with science-based assessments and seamless workflow management for employers and universities.",
    },
    "/candidate-support": {
      title: "Candidate Support - ASTRNT",
      description: "Need help with your job application? Visit ASTRNT's Candidate Support page for FAQs, guidance, and recruitment assistance.",
    },
    "/enter-code": {
        title: "Enter Code - ASTRNT",
        description: "Simply enter your unique code on ASTRNT to easily access your job application or assessment, and start your journey toward success with no hassle today.",
      },
    "/register": {
        title: "Register - ASTRNT",
        description: "Sign up today to streamline your hiring or admissions process with ASTRNT and experience a faster, more efficient solution tailored to your needs.",
    },
    "/solution/structured-hiring-astrnt": {
        title: "Talent Acquisition Solutions - ASTRNT",
        description: "Streamline your hiring with ASTRNT by quickly matching talent across blue-collar, professional, and graduate roles to transform your process.",
    },
    "/request-demo": {
        title: "Request a Demo - ASTRNT",
        description: "Request a free demo today and discover how ASTRNT can transform your hiring and admissions processes with faster, more efficient solutions.",
    },
    "/solution/university-admissi-astrnt": {
        title: "University Admission Solutions - ASTRNT",
        description: "Simplify student admissions with ASTRNT, designed to help you efficiently find top talent and optimize every step of the admissions process.",
    },
    "/solution/nextgen-assessment-center-astrnt": {
        title: "Talent Management Solutions - ASTRNT",
        description: "Reimagine talent management with NextGen Assessment Centers. Simplify hiring using asynchronous technology to save time, reduce costs, and boost efficiency.",
    },
    "/privacypolicy": {
        title: "Privacy Policy - ASTRNT",
        description: "Read ASTRNT’s privacy policy to understand how we protect your data, including how it's collected, used, and securely stored to ensure your privacy.",
    },
    "/termsofservice": {
        title: "Terms of Service - ASTRNT",
        description: "Check out ASTRNT’s terms of service to get familiar with the rules and guidelines for using our platform and services, ensuring a seamless experience.",
    },
    "/features": {
        title: "Pricing Plans - ASTRNT",
        description: "Explore ASTRNT’s pricing plans for recruitment or admissions, including free options, and find the perfect solution tailored to your needs and budget.",
    },
    "/how-it-works": {
        title: "How ASTRNT Works - ASTRNT",
        description: "Learn how ASTRNT’s platform simplifies recruitment and admissions processes. Discover how to use it and streamline your workflow with our easy-to-follow guide.",
    },
    "/partners": {
        title: "Partners - ASTRNT",
        description: "Collaborate with ASTRNT to transform hiring and admissions. Explore partnership opportunities and grow together.",
    },
    "/about": {
        title: "About Us - ASTRNT",
        description: "Discover ASTRNT's mission, vision, and the talented team behind our platform, transforming recruitment and admissions with innovative solutions and technology.",
    },
    "/learn": {
        title: "Learn - ASTRNT",
        description: "Explore ASTRNT's learning resources, articles, and insights to enhance your recruitment and talent management strategies.",
    },
    "/learn-search": {
        title: "Search Articles - ASTRNT",
        description: "Search through ASTRNT's comprehensive library of recruitment and talent management articles, guides, and best practices.",
    },
    "/professional": {
        title: "Professional Hiring - ASTRNT",
        description: "Transform professional hiring with ASTRNT's advanced assessment and interview solutions tailored for skilled roles.",
    },
    "/graduate": {
        title: "Graduate Hiring - ASTRNT",
        description: "Streamline graduate recruitment with ASTRNT's comprehensive assessment platform designed for early career talent.",
    },
    "/nextgen-assessment-center": {
        title: "NextGen Assessment Center - ASTRNT",
        description: "Experience the future of talent assessment with ASTRNT's NextGen Assessment Center technology.",
    },
    "/nextgen-rpo": {
        title: "NextGen RPO - ASTRNT",
        description: "Revolutionize your recruitment process outsourcing with ASTRNT's NextGen RPO solutions.",
    },
    "/talent-acquisition/professional": {
        title: "Professional Talent Acquisition - ASTRNT",
        description: "Enhance professional talent acquisition with ASTRNT's comprehensive assessment and interview platform.",
    },
    "/talent-acquisition/technical": {
        title: "Technical Talent Acquisition - ASTRNT",
        description: "Find top technical talent with ASTRNT's specialized technical assessment and coding evaluation tools.",
    },
    "/talent-acquisition/hourly": {
        title: "Hourly Worker Hiring - ASTRNT",
        description: "Optimize hourly worker recruitment with ASTRNT's efficient assessment and screening solutions.",
    },
    "/talent-acquisition/graduate": {
        title: "Graduate Talent Acquisition - ASTRNT",
        description: "Transform graduate hiring with ASTRNT's comprehensive early career talent assessment platform.",
    },
    "/talent-acquisition/astrnt-platform/ai-structured-video-interview": {
        title: "AI Video Interviews - ASTRNT",
        description: "Experience next-generation AI-powered structured video interviews with ASTRNT's innovative platform.",
    },
    "/talent-acquisition/skill-validation": {
        title: "Skill Validation - ASTRNT",
        description: "Validate candidate skills effectively with ASTRNT's comprehensive skill assessment and testing platform.",
    },
    "/talent-acquisition/astrnt-recommends": {
        title: "ASTRNT Recommends - ASTRNT",
        description: "Get AI-powered, role-based talent recommendations that help you shortlist faster, reduce bias, and hire with confidence.",
    },
    "/talent-acquisition/astrnt-platform/astrnt-recommends": {
        title: "ASTRNT Recommends - ASTRNT",
        description: "Get your best-fit talent recommendations, backed by talent background, psychometric assessments, video interviews, and competency data.",
    },
    "/apis": {
        title: "API Solutions - ASTRNT",
        description: "Integrate ASTRNT's powerful assessment and interview capabilities with your existing systems using our APIs.",
    },
    "/admissions": {
        title: "University Admissions - ASTRNT",
        description: "Transform university admissions with ASTRNT's comprehensive student assessment and evaluation platform.",
    },
    "/career-center": {
        title: "Career Center Solutions - ASTRNT",
        description: "Enhance career services with ASTRNT's comprehensive assessment and career development tools.",
    },
    "/talent-management/internal-mobility": {
        title: "Internal Mobility - ASTRNT",
        description: "Optimize internal talent mobility with ASTRNT's employee assessment and development solutions.",
    },
    "/talent-management/talent-mapping": {
        title: "Talent Mapping - ASTRNT",
        description: "Map and develop your organization's talent with ASTRNT's comprehensive talent assessment platform.",
    },
    "/talent-management/succession-planning": {
        title: "Succession Planning - ASTRNT",
        description: "Plan for future leadership with ASTRNT's succession planning and talent development tools.",
    },
    "/talent-management/high-potential-identification": {
        title: "High Potential Identification - ASTRNT",
        description: "Identify and develop high potential employees with ASTRNT's advanced assessment and evaluation tools.",
    },
    "/assessments-and-interviews": {
        title: "Assessments & Interviews - ASTRNT",
        description: "Comprehensive assessment and interview solutions for modern recruitment and talent evaluation.",
    },
    "/announcement-faq": {
        title: "Announcements & FAQ - ASTRNT",
        description: "Stay up to date with the latest ASTRNT platform announcements and find answers to frequently asked questions about updates and changes.",
    },

  };

if (window.location.hostname.match('test.astrnt.id') || window.location.hostname.match('astrnt.id')) {
	
    metaTags = {
        "/": {
          title: "ASTRNT – Mengubah Proses Rekrutmen dan Penerimaan Mahasiswa ",
          description: "ASTRNT optimalkan rekrutmen, penerimaan mahasiswa, dan manajemen talenta dengan asesmen berbasis sains serta alur kerja efisien untuk perusahaan dan universitas.",
        },
        "/candidate-support": {
          title: "Dukungan untuk Kandidat - ASTRNT",
          description: "Butuh bantuan melamar kerja? Kunjungi Dukungan Kandidat ASTRNT untuk FAQ, panduan, dan bantuan rekrutmen. ",
        },
        "/enter-code": {
            title: "Masukkan Kode - ASTRNT",
            description: "Masukkan kode unik di ASTRNT untuk mengakses lamaran atau asesmen kerja dan mulai perjalanan Anda hari ini.",
          },
        "/register": {
            title: "Daftar - ASTRNT",
            description: "Daftar sekarang untuk permudah proses rekrutmen atau penerimaan mahasiswa dengan ASTRNT, platform terbaik yang memanfaatkan teknologi untuk hasil lebih cepat.",
        },
        "/solution/structured-hiring-astrnt": {
            title: "Solusi Akuisisi Talenta - ASTRNT",
            description: "Permudah rekrutmen dengan ASTRNT, cocokkan talenta untuk posisi kerah biru, profesional, dan lulusan untuk transformasi proses Anda.",
        },
        "/request-demo": {
            title: "Demo - ASTRNT",
            description: "Minta demo gratis hari ini dan lihat bagaimana ASTRNT mengubah proses rekrutmen dan penerimaan mahasiswa dengan solusi teknologi terbaru yang efisien.",
        },
        "/solution/university-admissi-astrnt": {
            title: "Solusi Penerimaan Universitas - ASTRNT",
            description: "Permudah penerimaan mahasiswa dengan solusi ASTRNT, membantu Anda temukan talenta terbaik secara efisien dan optimalkan proses seleksi.",
        },
        "/solution/nextgen-assessment-center-astrnt": {
            title: "Solusi Manajemen Talenta - ASTRNT",
            description: "Ubah manajemen talenta dengan NextGen Assessment Centers. Permudah rekrutmen dengan teknologi asinkron untuk hemat waktu, biaya, dan tingkatkan efisiensi.",
        },
        "/privacypolicy": {
            title: "Kebijakan Privasi - ASTRNT",
            description: "Baca kebijakan privasi ASTRNT untuk memahami bagaimana kami melindungi data Anda, termasuk pengumpulan, penggunaan, dan keamanan.",
        },
        "/termsofservice": {
            title: "Syarat dan Ketentuan - ASTRNT",
            description: "Tinjau syarat dan ketentuan ASTRNT untuk memahami aturan penggunaan platform dan layanan kami, serta cara memaksimalkan fitur untuk rekrutmen dan penerimaan mahasiwa.",
        },
        "/features": {
            title: "Harga - ASTRNT",
            description: "Cek harga paket ASTRNT untuk rekrutmen atau penerimaan mahasiswa, ada yang gratis juga! Temukan solusi yang pas buat kebutuhan kamu di sini.",
        },
        "/how-it-works": {
            title: "Cara Kerja ASTRNT - ASTRNT",
            description: "Pelajari bagaimana ASTRNT mempermudah proses rekrutmen dan penerimaan mahasiswa dengan teknologi modern untuk hasil yang lebih cepat, efisien, dan terpercaya di sini.",
        },
        "/partnership": {
            title: "Peluang Kemitraan - ASTRNT",
            description: "Bergabung dengan ASTRNT untuk transformasi rekrutmen dan penerimaan mahasiswa. Temukan peluang kemitraan dan berkembang bersama.",
        },
        "/about": {
            title: "Tentang Kami - ASTRNT",
            description: "Temukan misi, visi, dan tim di balik ASTRNT, platform unggulan yang mentransformasi rekrutmen dan penerimaan dengan solusi teknologi terkini.",
        },
        "/learn": {
            title: "Belajar - ASTRNT",
            description: "Jelajahi sumber daya pembelajaran, artikel, dan wawasan ASTRNT untuk meningkatkan strategi rekrutmen dan manajemen talenta Anda.",
        },
        "/learn-search": {
            title: "Cari Artikel - ASTRNT",
            description: "Cari melalui perpustakaan komprehensif artikel rekrutmen dan manajemen talenta, panduan, dan praktik terbaik ASTRNT.",
        },
        "/professional": {
            title: "Rekrutmen Profesional - ASTRNT",
            description: "Transformasikan rekrutmen profesional dengan solusi asesmen dan wawancara canggih ASTRNT untuk posisi terampil.",
        },
        "/graduate": {
            title: "Rekrutmen Lulusan - ASTRNT",
            description: "Sederhanakan rekrutmen lulusan dengan platform asesmen komprehensif ASTRNT untuk talenta karir awal.",
        },
        "/nextgen-assessment-center": {
            title: "NextGen Assessment Center - ASTRNT",
            description: "Rasakan masa depan asesmen talenta dengan teknologi NextGen Assessment Center ASTRNT.",
        },
        "/nextgen-rpo": {
            title: "NextGen RPO - ASTRNT",
            description: "Revolusioner proses outsourcing rekrutmen Anda dengan solusi NextGen RPO ASTRNT.",
        },
        "/talent-acquisition/professional": {
            title: "Akuisisi Talenta Profesional - ASTRNT",
            description: "Tingkatkan akuisisi talenta profesional dengan platform asesmen dan wawancara komprehensif ASTRNT.",
        },
        "/talent-acquisition/technical": {
            title: "Akuisisi Talenta Teknis - ASTRNT",
            description: "Temukan talenta teknis terbaik dengan tools asesmen teknis dan evaluasi coding khusus ASTRNT.",
        },
        "/talent-acquisition/hourly": {
            title: "Rekrutmen Pekerja Harian - ASTRNT",
            description: "Optimalkan rekrutmen pekerja harian dengan solusi asesmen dan screening efisien ASTRNT.",
        },
        "/talent-acquisition/graduate": {
            title: "Akuisisi Talenta Lulusan - ASTRNT",
            description: "Transformasikan rekrutmen lulusan dengan platform asesmen talenta karir awal komprehensif ASTRNT.",
        },
        "/talent-acquisition/astrnt-platform/ai-structured-video-interview": {
            title: "Wawancara Video AI - ASTRNT",
            description: "Rasakan wawancara video terstruktur bertenaga AI generasi berikutnya dengan platform inovatif ASTRNT.",
        },
        "/talent-acquisition/skill-validation": {
            title: "Validasi Keahlian - ASTRNT",
            description: "Validasi keahlian kandidat secara efektif dengan platform asesmen dan testing keahlian komprehensif ASTRNT.",
        },
        "/talent-acquisition/astrnt-recommends": {
            title: "ASTRNT Recommends - ASTRNT",
            description: "Dapatkan rekomendasi talenta bertenaga AI berdasarkan peran untuk shortlist lebih cepat, mengurangi bias, dan merekrut dengan percaya diri.",
        },
        "/talent-acquisition/astrnt-platform/astrnt-recommends": {
            title: "ASTRNT Recommends - ASTRNT",
            description: "Dapatkan rekomendasi talenta terbaik berdasarkan latar belakang talenta, asesmen psikometri, wawancara video, dan data kompetensi.",
        },
        "/apis": {
            title: "Solusi API - ASTRNT",
            description: "Integrasikan kemampuan asesmen dan wawancara ASTRNT yang kuat dengan sistem existing Anda menggunakan API kami.",
        },
        "/admissions": {
            title: "Penerimaan Universitas - ASTRNT",
            description: "Transformasikan penerimaan universitas dengan platform asesmen dan evaluasi mahasiswa komprehensif ASTRNT.",
        },
        "/career-center": {
            title: "Solusi Career Center - ASTRNT",
            description: "Tingkatkan layanan karir dengan tools asesmen dan pengembangan karir komprehensif ASTRNT.",
        },
        "/talent-management/internal-mobility": {
            title: "Mobilitas Internal - ASTRNT",
            description: "Optimalkan mobilitas talenta internal dengan solusi asesmen dan pengembangan karyawan ASTRNT.",
        },
        "/talent-management/talent-mapping": {
            title: "Pemetaan Talenta - ASTRNT",
            description: "Petakan dan kembangkan talenta organisasi Anda dengan platform asesmen talenta komprehensif ASTRNT.",
        },
        "/talent-management/succession-planning": {
            title: "Perencanaan Suksesi - ASTRNT",
            description: "Rencanakan kepemimpinan masa depan dengan tools perencanaan suksesi dan pengembangan talenta ASTRNT.",
        },
        "/talent-management/high-potential-identification": {
            title: "Identifikasi High Potential - ASTRNT",
            description: "Identifikasi dan kembangkan karyawan berpotensi tinggi dengan tools asesmen dan evaluasi canggih ASTRNT.",
        },
        "/assessments-and-interviews": {
            title: "Asesmen & Wawancara - ASTRNT",
            description: "Solusi asesmen dan wawancara komprehensif untuk rekrutmen modern dan evaluasi talenta.",
        },
        "/announcement-faq": {
            title: "Pengumuman & FAQ - ASTRNT",
            description: "Dapatkan informasi terbaru tentang pembaruan platform ASTRNT dan temukan jawaban atas pertanyaan umum seputar pembaruan dan perubahan.",
        },

      };
}
  
  export default metaTags;